import { render, staticRenderFns } from "./LoaderBar.vue?vue&type=template&id=8013fda6&"
import script from "./LoaderBar.vue?vue&type=script&lang=js&"
export * from "./LoaderBar.vue?vue&type=script&lang=js&"
import style0 from "./LoaderBar.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports